module.exports = __webpack_public_path__ + "static/img/down.d766612.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/down.jpg
// module id = 5Sng
// module chunks = 2